var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoApple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.132,20.609a19.148,19.148,0,0,1-1.73,3.234c-1.125,1.712-2.713,3.85-4.674,3.863-1.746.016-2.2-1.139-4.567-1.119S14.3,27.728,12.55,27.71c-1.963-.018-3.465-1.943-4.59-3.653-3.148-4.794-3.481-10.414-1.535-13.4a6.965,6.965,0,0,1,5.6-3.365c2.083,0,3.392,1.144,5.113,1.144,1.671,0,2.688-1.146,5.1-1.146a6.8,6.8,0,0,1,5.122,2.7A5.864,5.864,0,0,0,28.132,20.609ZM20.4,5.373a5.841,5.841,0,0,0,1.3-4.33,6.321,6.321,0,0,0-4.076,2.192,5.434,5.434,0,0,0-1.334,4.223A5.315,5.315,0,0,0,20.4,5.373Z",
    fill: "#1d1d1f",
    transform: "translate(-2 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoApple);
export default __webpack_public_path__ + "static/media/ico_apple.16a3736e5b244ce8e5b6e07d9606b20a.svg";
export { ForwardRef as ReactComponent };